import GridContainerWrapper from 'components/@common/GridContainerWrapper'
import { InitialStateType } from 'initialState'
import DriverDetails from 'pages/DriverDetails'
import DrivingLicence from 'pages/DrivingLicence'
import Payment from 'pages/Payment'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { Grid } from 'unsemantic'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingScreen from '../../components/LoadingScreen'
import { Secure } from '../JudoPay/Secure'
import LegalDeclarationPage from '../LegalDeclarationPage'
import MoreDetails from '../MoreDetails'
import { initRiskDataCollectionPage } from './actions'
import RiskDataDiscountBanner from './components/RiskDataDiscountBanner'

const MainContainer = styled.div`
  text-align: center;
`

const RiskDataCollectionPage = () => {
  const dispatch = useDispatch()
  const loading = useSelector((state: InitialStateType) => state.isLoading)

  useEffect(() => {
    // @ts-ignore

    if (!window.isHoldingPageOn) {
      setTimeout(() => {
        dispatch(initRiskDataCollectionPage())
      }, 1000)
    }
  }, [dispatch])

  if (loading) {
    return (
      <Grid desktop='100' parent>
        <LoadingScreen />
      </Grid>
    )
  }

  return (
    <Grid desktop='100' parent>
      <MainContainer>
        <RiskDataDiscountBanner />
        <GridContainerWrapper>
          <Breadcrumb />
        </GridContainerWrapper>
        <Switch>
          <Route
            path='/quote/driver-details/more-info'
            component={MoreDetails}
          />
          <Route path='/quote/driver-details' component={DriverDetails} />
          <Route path='/quote/payment/3d-secure' component={Secure} />
          <Route path='/quote/payment' component={Payment} />
          <Route path='/quote/driving-licence' component={DrivingLicence} />
          <Route
            path='/quote/legal-declaration'
            component={LegalDeclarationPage}
          />
        </Switch>
      </MainContainer>
    </Grid>
  )
}

export default RiskDataCollectionPage
